/**
 * Consult form
 */
import AjaxForm from '../AjaxForm';


export default {
  mixins: [AjaxForm],

  props: {
    api    : String,
    method : String,
    comment: Boolean,
  },

  data() {
    return {
      model: {
        name   : '',
        tel    : '',
        message: '',
        accept : true,
      },
    };
  },
};



// WEBPACK FOOTER //
// ./source/js/components/ConsultForm/ConsultForm.js